import { useEffect } from 'react';
import { useForm } from '../FormContext';

// Provides common functionality for FormFields. This should be called by each FormField component
export const useFormField = (
  field, // the primary string identifier of this formField
  valueKeys, // valueKeys is an array of Strings that this FormField is responsible for setting in the formValues object
  validate, // A function that is expected to return a string if there is an error, or null if there is no error
  hint,
) => {
  const {
    formValues,
    errorStates,
    assignErrorState,
    touchedStates,
    assignTouchedState,
    enqueueCleanup,
    variant = 'standard',
  } = useForm();

  // On mount, set the touchedState to false and prepare unmount logic
  useEffect(() => {
    assignTouchedState(field, false);
    return () => {
      // Defer cleanup so it only applies while the Form is still mounted.
      enqueueCleanup({ field, valueKeys });
    };
  }, []);

  // Rerun validation each time formValues changes
  useEffect(() => {
    if (validate) {
      const errorState = validate();
      assignErrorState(field, errorState);
    }
  }, [formValues]);

  return {
    onBlur: () => assignTouchedState(field, true),
    error: touchedStates[field] && Boolean(errorStates[field]),
    helperText: touchedStates[field] ? (errorStates[field] ?? hint) : hint,
    variant: variant,
  };
};
